import React from 'react';
import './_styles_/MiddleContainer.css';
import LeftMenuWrapper from './LeftMenuWrapper';
import MainContent from './MainContent';

function MiddleContainer() {
    return (
        <div className="middle-container">
            <div className="middle-container--box">
                <LeftMenuWrapper />
                <MainContent />
            </div>
        </div>
    );
}

export default MiddleContainer;
